import store from '@/store/store'

export default function Utils(app) {
  app.api.Utils = Object.freeze({
    getMediaType,

    getBrowser,
    preloadVideo,
    preloadImage
  })


  function getMediaType(src) {
    // regular expression to match image and video file extensions
    var imageExtensions = /\.(jpe?g|png|gif|bmp|webp|svg)$/i;
    var videoExtensions = /\.(mp4|m4v|ogg|webm|mkv|flv|avi|wmv|mov)$/i;

    // determine the file type based on the src string
    let fileType = 'unknown';
    if (src.match(imageExtensions)) {
      fileType = 'image';
    } else if (src.match(videoExtensions)) {
      fileType = 'video';
    }

    return fileType;
  }


  function getBrowser() {
    // Get the user agent string
    const userAgent = navigator.userAgent;

    // Check for Microsoft Edge
    if (userAgent.indexOf("Edge") > -1) {
      return "Microsoft Edge";
    }

    // Check for Opera
    if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
      return "Opera";
    }

    // Check for Chrome
    if (userAgent.indexOf("Chrome") > -1) {
      return "Google Chrome";
    }

    // Check for Safari
    if (userAgent.indexOf("Safari") > -1) {
      return "Safari";
    }

    // Check for Firefox
    if (userAgent.indexOf("Firefox") > -1) {
      return "Mozilla Firefox";
    }

    // Default to other
    return "Unknown";
  }


  async function preloadVideo(src) {
    let realSrc = getMediaPath(src)

    // Fetch the video using the specified src
    const response = await fetch(realSrc);

    // Check if the fetch was successful
    if (!response.ok) {
      throw new Error(`Error preloading video: ${response.statusText}`);
    }

    // Check the content type of the response
    const contentType = response.headers.get('content-type');
    if (!contentType.includes('video/mp4') && getBrowser() == "Safari") {
      console.log('Invalid video content type or format for current browser Safari.');
      return Promise.resolve()
    }

    // Get the video data from the response
    const videoBlob = await response.blob();

    // Create an object URL from the video data
    const videoUrl = URL.createObjectURL(videoBlob);

    // Create a new video element
    const video = document.createElement('video');
    video.preload = 'auto';
    video.setAttribute('playsinline', '');

    // Set the src of the video to the object URL
    video.src = videoUrl;

    // Return a promise that resolves once the video has finished preloading
    return new Promise((resolve, reject) => {
      video.addEventListener('canplay', () => {
        resolve();
      });
      video.addEventListener('error', () => {
        reject(new Error('Video preload failed.'));
      });
      video.load();
    });
  }


  async function preloadImage(src) {
    // create Image element and append it to the dom for preload
    const image = new Image();
    image.src = getMediaPath(src);
    image.onerror = function (error) {
      console.error(`Error preloading image: ${error}`);
    };
  }
}